<template lang="pug">
aside-modal#item-bulk-modal(width="w-xxl" :loading="loading")

    span(slot="header-text") Edit Products

    .p-a(slot="body")
        item-bulk(ref="itemBulk")

    button.btn.btn-fw.primary(slot="footer" :disabled="loading" @click="submit")
        v-loading(loader="save-product") Save
</template>

<script>
import { Event } from '../../../event-bus';
import ItemBulk from './item-bulk';
import ModalMixin from '@js/mixins/modals';

export default {
    components: {
        ItemBulk,
    },

    mixins: [ModalMixin],

    computed: {
        loading() {
            return this.onLoading('save-product');
        },
    },

    created() {
        Event.$on('bulk-product-updated', u => this.onProductUpdated());
    },

    methods: {
        onProductUpdated() {
            this.hideModal();
        },

        submit() {
            this.$refs.itemBulk.submit();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/item/item-bulk-modal.vue